"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeTooltipStyles = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var msToNumber = function msToNumber(ms) {
  return parseInt(ms.slice(0, -2));
};

var makeTooltipStyles = function makeTooltipStyles(_ref) {
  var primitives = _ref.primitives,
      tokens = _ref.tokens;
  var _primitives$transitio = primitives.transitions,
      duration = _primitives$transitio.duration,
      easing = _primitives$transitio.easing;
  return {
    MuiTooltip: {
      defaultProps: {
        TransitionProps: {
          timeout: {
            enter: msToNumber(duration[1]),
            exit: msToNumber(duration[4])
          },
          easing: {
            enter: easing["slow-down"],
            exit: easing["speed-up"]
          }
        }
      },
      styleOverrides: {
        popper: {
          '& [class*="MuiTooltip-arrow"]': {
            fontSize: primitives.spacings[2],
            "&::before": {
              backgroundColor: tokens.colors["detail-2-opaque"].color
            }
          },
          '& [class*="MuiTooltip-tooltip"]': _objectSpread({
            backgroundColor: tokens.colors["detail-2-opaque"].color,
            padding: "".concat(primitives.spacings["2"], " ").concat(primitives.spacings["3"]),
            color: tokens.colors["ink-on-fill-primary"].color,
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            borderRadius: primitives.borderRadii.small,
            '& [class*="MuiTypography-root"]': {
              color: tokens.colors["ink-on-fill-primary"].color
            },
            ".MuiDivider-root": {
              marginTop: primitives.spacings["2"],
              marginBottom: primitives.spacings["2"]
            }
          }, tokens.typography.smallprint)
        }
      }
    }
  };
};

exports.makeTooltipStyles = makeTooltipStyles;